import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RestoreIcon from '@mui/icons-material/Restore';
import DeleteIcon from '@mui/icons-material/Delete';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { CartItem } from '../../QuickSaleScreen'; // Gerekli tipleri import edelim
import { Customer } from '../../QuickSaleScreen'; // Gerekli tipleri import edelim

// Beklemeye alınan satış verisi için arayüz
export interface PendingSale {
  id: number; // Benzersiz ID (örn: timestamp)
  timestamp: number; // Kayıt zamanı
  totalAmount: number; // Toplam tutar
  cartItems: CartItem[]; // Sepet içeriği
  selectedCustomer: Customer | null; // Seçili müşteri
}

// Modal için prop arayüzü
interface PendingSalesModalProps {
  open: boolean;
  onClose: () => void;
  pendingSales: PendingSale[];
  onRestoreSale: (saleId: number) => void;
  onDeleteSale: (saleId: number) => void;
}

const PendingSalesModal: React.FC<PendingSalesModalProps> = ({
  open,
  onClose,
  pendingSales,
  onRestoreSale,
  onDeleteSale,
}) => {

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(amount);
  };

  const formatDateTime = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleString('tr-TR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PauseCircleOutlineIcon sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="h6" component="span">Beklemeye Alınan Satışlar</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {pendingSales.length === 0 ? (
          <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
            (Henüz beklemeye alınmış satış bulunmuyor)
          </Typography>
        ) : (
          <List disablePadding>
            {pendingSales.sort((a, b) => b.timestamp - a.timestamp).map((sale, index) => (
              <React.Fragment key={sale.id}>
                <ListItem 
                  secondaryAction={
                    <Box>
                      <IconButton 
                        edge="end" 
                        aria-label="getir" 
                        onClick={() => onRestoreSale(sale.id)}
                        color="primary"
                        sx={{ mr: 0.5 }}
                      >
                        <RestoreIcon />
                      </IconButton>
                      <IconButton 
                        edge="end" 
                        aria-label="sil" 
                        onClick={() => onDeleteSale(sale.id)}
                        color="error"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  }
                >
                  <ListItemText
                    primary={`Tarih: ${formatDateTime(sale.timestamp)}`}
                    secondary={`Müşteri: ${sale.selectedCustomer?.companyName || 'Genel Müşteri'} - Tutar: ${formatCurrency(sale.totalAmount)}`}
                  />
                </ListItem>
                {index < pendingSales.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1 }}>
        <Button onClick={onClose} color="inherit">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PendingSalesModal; 